import Link from 'next/link';
import { type GameMeta, type Locale, pick } from './registry';

const CTA: Record<Locale, string> = {
  zh: '开始游戏',
  en: 'Play',
};

/**
 * A game card on the portal home. No client interactivity of its own — it's a
 * styled `<Link>`. Usable from both server and client parents.
 */
export function GameCard({ game, locale }: { game: GameMeta; locale: Locale }) {
  const tags = game.tags[locale] ?? game.tags.en;
  return (
    <Link className="game-card" href={`/play/${game.slug}`}>
      <div className="game-card-cover" style={{ background: game.accent }}>
        <span aria-hidden>{game.icon}</span>
      </div>
      <div className="game-card-body">
        <h2 className="game-card-title">{pick(game.title, locale)}</h2>
        <p className="game-card-desc">{pick(game.description, locale)}</p>
        {tags.length > 0 ? (
          <div className="game-card-tags">
            {tags.map((tag) => (
              <span key={tag} className="game-card-tag">{tag}</span>
            ))}
          </div>
        ) : null}
        <span className="game-card-cta">{CTA[locale]} →</span>
      </div>
    </Link>
  );
}
